import axios from "axios";
import { Baseurl } from "../baseurl";

export const fetchEmployees = async () => {
  try {
    const resp = await axios.get(`${Baseurl}/api/employees/all`);
    return resp.data
  } catch (error) {
    console.error("Error fetching employees:", error);
  }
};
